"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportUserLeaderboardData = exports.exportTeamLeaderboardData = exports.fetchCourseDashboardDataTeamFilter = exports.fetchCourseDashboardData = exports.fetchAdminDashboardAllCourses = exports.fetchAdminDashboardDataTeamFilter = exports.fetchAdminDashboardData = void 0;
var rest_1 = __importStar(require("../../rest"));
var fetchAdminDashboardData_1 = __importDefault(require("../mock/fetchAdminDashboardData"));
var combinePlatformUrl_1 = __importDefault(require("./combinePlatformUrl"));
var baseDashboardPath = '/api/v2/dashboards';
var dashboardStatisticsUrl = "".concat(baseDashboardPath, "/dashboard_statistics");
var fetchAdminDashboardData = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, rest_1.default.get({
                mockFunc: function () { return (0, fetchAdminDashboardData_1.default)('main_dashboard_page'); },
                url: (0, combinePlatformUrl_1.default)(dashboardStatisticsUrl),
            })];
    });
}); };
exports.fetchAdminDashboardData = fetchAdminDashboardData;
var getTeamsString = function (teams, isFirstQueryString) {
    if (isFirstQueryString === void 0) { isFirstQueryString = false; }
    if (isFirstQueryString) {
        var teamString = teams.map(function (team) { return "team_ids[]=".concat(team); }).join('&');
        return teamString.length > 0 ? "?".concat(teamString) : teamString;
    }
    return teams.map(function (team) { return "&team_ids[]=".concat(team); }).join('');
};
var fetchAdminDashboardDataTeamFilter = function (teams) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, rest_1.default.get({
                mockFunc: function () { return (0, fetchAdminDashboardData_1.default)('main_dashboard_team_filter'); },
                url: (0, combinePlatformUrl_1.default)("".concat(dashboardStatisticsUrl, "?fetch_for=main_dashboard_team_filter").concat(getTeamsString(teams))),
            })];
    });
}); };
exports.fetchAdminDashboardDataTeamFilter = fetchAdminDashboardDataTeamFilter;
var fetchAdminDashboardAllCourses = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, rest_1.default.get({
                mockFunc: function () { return (0, fetchAdminDashboardData_1.default)('all_courses_page'); },
                url: (0, combinePlatformUrl_1.default)("".concat(dashboardStatisticsUrl, "?fetch_for=all_courses_page")),
            })];
    });
}); };
exports.fetchAdminDashboardAllCourses = fetchAdminDashboardAllCourses;
var fetchCourseDashboardData = function (courseId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, rest_1.default.get({
                mockFunc: function () { return (0, fetchAdminDashboardData_1.default)('course_dashboard_page'); },
                url: (0, combinePlatformUrl_1.default)("".concat(dashboardStatisticsUrl, "?fetch_for=course_dashboard_page&course_id=").concat(courseId)),
            })];
    });
}); };
exports.fetchCourseDashboardData = fetchCourseDashboardData;
var fetchCourseDashboardDataTeamFilter = function (teams, courseId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, rest_1.default.get({
                mockFunc: function () { return (0, fetchAdminDashboardData_1.default)('course_dashboard_team_filter'); },
                url: (0, combinePlatformUrl_1.default)("".concat(dashboardStatisticsUrl, "?fetch_for=course_dashboard_team_filter&course_id=").concat(courseId).concat(getTeamsString(teams))),
            })];
    });
}); };
exports.fetchCourseDashboardDataTeamFilter = fetchCourseDashboardDataTeamFilter;
var exportTeamLeaderboardData = function (teams) {
    (0, rest_1.downloadFile)((0, combinePlatformUrl_1.default)("".concat(baseDashboardPath, "/export_teams_leaderboard_dashboard").concat(getTeamsString(teams, true))));
};
exports.exportTeamLeaderboardData = exportTeamLeaderboardData;
var exportUserLeaderboardData = function (teams) {
    (0, rest_1.downloadFile)((0, combinePlatformUrl_1.default)("".concat(baseDashboardPath, "/export_user_leaderboard_dashboard").concat(getTeamsString(teams, true))));
};
exports.exportUserLeaderboardData = exportUserLeaderboardData;
